import React from "react";
import { MapContainer, Marker, Polyline, TileLayer } from "react-leaflet";
import L from "leaflet";
import spotGreenIcon from "../../assets/icons/map-icon.svg";
import InvalidateMapSizeWhenVisible from "./InvalidateMapSizeWhenVisible";

const spotIcon = L.icon({ iconUrl: spotGreenIcon, iconSize: [60, 40], iconAnchor: [30, 40] });

export default function SpotMiniMap({ latitude, longitude, title, fishingFromBoat, routes = [], isVisible = true }) {
    if (!Number.isFinite(Number(latitude)) || !Number.isFinite(Number(longitude))) {
        return null;
    }

    const lat = Number(latitude);
    const lng = Number(longitude);
    const pos = [lat, lng];
    const mapKey = `${lat.toFixed(5)}:${lng.toFixed(5)}:${routes.map((route) => route.id).join(",")}`;

    return (
        <div className="spot-mini-map" aria-label={title ? `Карта: ${title}` : "Карта точки"}>
            <MapContainer key={mapKey} center={pos} zoom={15} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
                <InvalidateMapSizeWhenVisible isVisible={isVisible} />
                <TileLayer attribution="&copy; OpenStreetMap contributors" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {routes.map((route) => {
                    const line = (route?.geometry?.coordinates || [])
                        .filter((point) => Array.isArray(point) && point.length >= 2)
                        .map((point) => [Number(point[1]), Number(point[0])])
                        .filter((point) => Number.isFinite(point[0]) && Number.isFinite(point[1]));
                    if (line.length < 2) {
                        return null;
                    }
                    return <Polyline key={route.id} positions={line} pathOptions={{ color: "#1e6f5c", weight: 4 }} />;
                })}
                <Marker position={pos} icon={spotIcon} />
            </MapContainer>
        </div>
    );
}
